import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useProviderList(params) {
  return useSWR(
    {
      path: `/api/v1/providers`,
      method: "GET",
      params,
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useProviderList;
